// WARNING: this file is AUTOGENERATED, only main.ts and index.ts are editable
// rerun yarn generate:enums to update

/* eslint-disable */
interface IParsedVisibility {
  Private: {"enum_constant":"Private"};
  Public: {"enum_constant":"Public"};
  Unlisted: {"enum_constant":"Unlisted"};
}

export type VisibilityId = keyof IParsedVisibility;
export type VisibilityData = IParsedVisibility[VisibilityId];
const data: VisibilityData[] = [{"enum_constant":"Private"},{"enum_constant":"Public"},{"enum_constant":"Unlisted"}];
export default data;
